// extracted by mini-css-extract-plugin
export default {"container":"background_box-module__container--1uWNR"};